import { useTheme } from '@emotion/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { images } from 'app/constants/images';

// Local Typings
export type LogoVariant = 'dark' | 'light';
export type LogoSize = 'large' | 'medium' | 'small';
interface Props {
  size?: LogoSize;
  variant?: LogoVariant;
}

// Local Variables

const logoNewSizes: Record<LogoSize, number> = {
  large: 150,
  medium: 141,
  small: 116,
};

// Component Definition
const Logo: FC<Props> = ({
  size = 'medium',
  variant = 'dark',
}) => {
  const { t } = useTranslation('components');

  const theme = useTheme();

  const shouldUseLightLogo = variant === 'light' || theme.mode === 'dark';

  return (
    <img
      alt={t('logo.altText', 'Triumph Logo which navigates to dashboard')}
      className="logo"
      src={shouldUseLightLogo ? images.logoNewLight.full : images.logoNew.full}
      width={logoNewSizes[size]}
    />
  );
};

export default Logo;
